module.exports = __webpack_public_path__ + "img/angela-sung-on-tokyo-streets.4cf18d6.jpg";